import React from 'react';
import { Typography, Box, Grid, CardMedia } from '@mui/material';

const TrustedBy = () => {
	const features = [
		'100% No Compromise in Quality and Quantity',
		'Full-Service for All Your Events',
		'Easy Customization Options',
		'Delicious Deals for Delicious Meals',
	];

	return (
		<Box
			sx={{
				padding: 0,
				position: 'relative',
			}}
		>
			<Grid
				container
				spacing={2}
				display="flex"
				justifyContent="space-between"
				alignItems="center"
			>
				<Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
					<Box display={'flex'} flexDirection={'row'} width="100%">
						<Grid
							size={{ xs: 12, sm: 12, md: 3, lg: 3 }}
							sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}
						/>
						<Grid
							size={{ xs: 12, sm: 12, md: 9, lg: 9 }}
							display="flex"
							justifyContent="flex-start"
							alignItems="center"
						>
							<Box
								display={'flex'}
								flexDirection={'column'}
								alignItems="center"
								justifyContent={'flex-start'}
								width={'100%'}
							>
								<Typography
									color="primary"
									variant="body1"
									fontWeight={700}
									gutterBottom
									width={'inherit'}
									height={'2.5rem'}
								>
									<Typography variant="overline" fontSize={'23.25px'}>
										-
									</Typography>{' '}
									Our Story{' '}
									<Typography variant="overline" fontSize={'23.25px'}>
										-
									</Typography>
								</Typography>
								<Typography
									variant="h3"
									gutterBottom
									className="mb-4"
									width={'inherit'}
								>
									Trusted By 1200 + Satisfied Clients
								</Typography>
								<Typography variant="subtitle2" color="secondary" width={'inherit'}>
									We deliver excellence with every project. Your trust drives our
									commitment to quality and innovation!
								</Typography>
								<Box mt={2} width={'100%'}>
									{features.map((feature, index) => (
										<Box
											key={index}
											display="flex"
											alignItems="center"
											justifyContent={'flex-start'}
											mb={1}
											sx={{
												boxShadow: `0px 0px 12.92px 0px #00000014`,
												width: '100%',
												padding: '7px 10px',
											}}
										>
											<CardMedia
												component="img"
												image="/assets/convey.svg"
												alt="bullet-icon"
												sx={{
													width: '16px',
													height: '16px',
													marginRight: '8px',
												}}
											/>
											<Typography
												variant="body1"
												// fontSize={'12px'}
												color="error"
											>
												{feature}
											</Typography>
										</Box>
									))}
								</Box>
							</Box>
						</Grid>
					</Box>
				</Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
					sx={{ display: { xs: 'none', md: 'flex' } }}
				>
					<Grid
						size={{ xs: 12, sm: 12, md: 7, lg: 7 }}
						sx={{ display: { xs: 'none', sm: 'none', md: 'block' }, margin: 'auto' }}
					>
						<CardMedia
							component="img"
							image="/assets/story.png"
							alt="woman-in-sari"
							sx={{
								width: '100%',
								height: 'auto',
								objectFit: 'contain',
							}}
						/>
					</Grid>

					<Grid
						size={{ xs: 12, md: 5, lg: 5 }}
						sx={{ display: { xs: 'none', md: 'block' } }}
					>
						<CardMedia
							component="img"
							image="/assets/woman-colorful-sari.png"
							alt="Woman in Sari"
							sx={{ width: '100%', height: 'auto', objectFit: 'contain' }}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Box>
	);
};

export default TrustedBy;
